module.exports = __webpack_public_path__ + "img/PG6-1-498x299.7c8621a4.png";